import React from "react";

import { selectStore } from "modules/customer/insights/portfolioNew/portfolioSlice";
import { useAppSelector } from "store";

const Subtitle: React.FC = () => {
    const store = useAppSelector(selectStore);

    return (
        <>
            Check how well your {store?.name} store fits its surroundings.
            Look at nearby brand mix and points of interest to explore what might be shaping performance.
        </>
    );
};

export default Subtitle;
